// The subscription email's manage-or-cancel link is /overview?settings=billing. A signed-out recipient goes through
// sign-in first, which lands back on the home page without the query string, so the request is remembered for a
// short while when the page loads and honored once the signed-in app mounts. It is forgotten when Settings is
// closed rather than when it opens, because an expired session opens it and is then sent to sign in.
const BILLING_SETTINGS_LINK_KEY = 'billing_settings_link_at'
export const BILLING_SETTINGS_LINK_MAX_AGE_MS = 30 * 60 * 1000

export const isBillingSettingsLink = (search: string) => new URLSearchParams(search).get('settings') === 'billing'

export const rememberBillingSettingsLink = (search: string, now = Date.now()) => {
    if (!isBillingSettingsLink(search)) return
    try {
        window.localStorage.setItem(BILLING_SETTINGS_LINK_KEY, String(now))
    } catch {
        // storage can be unavailable (private browsing); the query string still works when signed in
    }
}

export const hasRememberedBillingSettingsLink = (now = Date.now()) => {
    try {
        const rememberedAt = Number(window.localStorage.getItem(BILLING_SETTINGS_LINK_KEY))
        return rememberedAt > 0 && now - rememberedAt <= BILLING_SETTINGS_LINK_MAX_AGE_MS
    } catch {
        return false
    }
}

export const forgetBillingSettingsLink = () => {
    try {
        window.localStorage.removeItem(BILLING_SETTINGS_LINK_KEY)
    } catch {
        // nothing was stored
    }
}
